import { createContext, useContext } from 'react'

export type FieldDensity = 'comfortable' | 'compact'

const FieldDensityContext = createContext<FieldDensity>('comfortable')

export const FieldDensityProvider = FieldDensityContext.Provider

export function useFieldDensity(): FieldDensity {
  return useContext(FieldDensityContext)
}
